import { internationalLocation, countryLocation, usStates, militaryZones, domesticClientCodes } from '../components/ScannedPackageDetails/PackageDetailsValues'

export const getFormattedDate = (date) => {
  date = new Date(date)
  return date.toLocaleString('en-US')
}

const padTo2Digits = (num) => {
  return num.toString().padStart(2, '0')
}

export const formatDate = (date) => {
  date = convertToMountainTime(date)
  return (
    [
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
      date.getFullYear()
    ].join('/') +
    ' ' +
    [
      padTo2Digits(date.getHours()),
      padTo2Digits(date.getMinutes()),
      padTo2Digits(date.getSeconds())
    ].join(':')
  )
}

// Convert local time to Mountain Time
export const convertToMountainTime = (date) => {
  date = new Date(date)
  return new Date(
    date.toLocaleString('en-US', {
      timeZone: 'America/Denver'
    })
  )
}

export const logApiTime = (startTime, endTime) => {
  let numberOfCalls = 0
  let totalTime = 0
  let quickest = 0
  let longest = 0
  let average = 0
  const delta = (endTime - startTime) / 1000
  let noOfCalls = 0
  let longerTime = 0
  let shorterTime = 0
  let overAllTime = 0
  let scanTimes = 0
  let allScanTimes = 0
  noOfCalls = localStorage.getItem('NumberOfCalls')
  longerTime = localStorage.getItem('Longest')
  shorterTime = localStorage.getItem('Quickest')
  overAllTime = localStorage.getItem('TotalTime')
  scanTimes = localStorage.getItem('ScanTimes')

  if (longerTime !== null && longerTime !== 'NaN') {
    longest = parseFloat(longerTime)
  }
  if (shorterTime !== null && shorterTime !== 'NaN') {
    quickest = parseFloat(shorterTime)
  }
  if (overAllTime !== null && overAllTime !== 'NaN') {
    totalTime = parseFloat(overAllTime)
  }
  if (scanTimes !== null && scanTimes !== 'NaN') {
    allScanTimes = scanTimes
  }
  if (delta > longest) {
    longest = delta
  }
  if (delta < quickest) {
    quickest = delta
  }
  if (quickest === 0) {
    quickest = delta
  }
  totalTime += delta
  if (noOfCalls !== null && noOfCalls !== 'NaN') {
    numberOfCalls = parseInt(noOfCalls) + 1
  } else {
    numberOfCalls += 1
  }
  average = totalTime / numberOfCalls
  if (allScanTimes !== 0) {
    allScanTimes = allScanTimes + ',' + delta
  } else {
    allScanTimes = delta
  }

  localStorage.setItem('NumberOfCalls', numberOfCalls)
  localStorage.setItem('Longest', longest)
  localStorage.setItem('Quickest', quickest)
  localStorage.setItem('TotalTime', totalTime)
  localStorage.setItem('Average', average)
  localStorage.setItem('ScanTimes', allScanTimes)
}

// International Address Validation Utilities

// Check if any value in comma-separated string matches international location
export const validateInternationalAddress = (values) => {
  if (!values) return false
  const splitValues = values.split(/,+/).filter(element => element)
  for (const e of splitValues) {
    const result = internationalLocation.filter(x => String(x.value) === e?.toLowerCase().trim())
    if (result.length > 0) {
      return true
    }
  }
  return false
}

export const validateInternationalAddressCombined = (state, city, country, clientId) => {
  // Skip international validation if client code is domestic (C867, C862)
  if (clientId && domesticClientCodes.includes(clientId)) {
    return false
  }

  const stateCode = state?.toUpperCase()?.trim() || ''
  const cityCode = city?.toUpperCase()?.trim() || ''
  const countryCode = country?.toLowerCase()?.trim() || ''

  const cityValues = cityCode ? cityCode.split(/,+/).map(c => c.trim()).filter(c => c.length > 0) : []

  // Military cities are always domestic regardless of country/state
  const hasMilitaryCity = cityValues.some(c => militaryZones.includes(c))
  if (hasMilitaryCity) {
    return false
  }

  if (validateInternationalAddress(state) || validateInternationalAddress(city) || validateInternationalAddress(country)) {
    return true
  }

  // Foreign country OR foreign state should be INTERNATIONAL
  const isForeignCountry = countryCode && !countryLocation.some(country => country.value === countryCode)
  const isForeignState = stateCode && stateCode !== '' && !usStates.includes(stateCode)

  if (isForeignCountry || isForeignState) {
    return true
  }

  const isEmptyOrNonUSCountry = !countryCode || !countryLocation.some(country => country.value === countryCode)
  const isNonUSState = !stateCode || (stateCode !== '' && !usStates.includes(stateCode))
  const isNonMilitaryCity = cityValues.length === 0 || cityValues.some(c => !militaryZones.includes(c))

  return isEmptyOrNonUSCountry && isNonUSState && isNonMilitaryCity
}
